module.exports = __webpack_public_path__ + "media/images/expert__jeff-baltermia-4e3a09d9d96ebd804f773df9854214c5.png";